<template>
  <div class="layout-content-list">
    <el-breadcrumb separator="/" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>异常定位管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">日期</span>
        <el-date-picker
          v-model="filter.startDate"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          placeholder="选择开始日期"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filter.endDate"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="selectTimeChange"
          placeholder="选择结束日期"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">筛选条件</span>
        <el-input
          v-model.trim="filter.keyword"
          style="width: 300px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="区域、详细地址、地址类型、操作人"
        ></el-input>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="handleSearch" id="auto-2">筛选</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">异常定位管理列表</div>
      <div class="fr">
        <el-button type="primary" size="small" @click="handleAdd" id="auto-3">添加地址</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-4">
      <el-table :data="tableData.data" border>
        <el-table-column prop="regionName" label="区域" min-width="180"> </el-table-column>
        <el-table-column prop="addressName" label="详细地址" min-width="240"> </el-table-column>
        <el-table-column prop="addressLabel" label="地址类型" min-width="160"> </el-table-column>
        <el-table-column prop="createUsername" label="操作人" width="160"> </el-table-column>
        <el-table-column prop="createTime" label="添加日期" width="160">
          <template v-slot="scope">
            {{ scope.row.createTime | stamp2TextDateFull(2) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="handleToMap(scope.row)" class="font-blue">查看定位</el-button>
            <el-button type="text" size="small" @click="handleRemove(scope.row)">移除白名单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axiosNew from '@/api/axiosNew';
import api from '@/api/logistics.api';
import dateLimit from '@/api/dateLimit';
import { WUYI, vali } from '@/api/common';
export default {
  name: 'AbnomalLocation',
  data: function () {
    return {
      currentPage: 1,
      pageSize: 20,
      companyCode: WUYI.currentData.company.companycode,
      filter: {
        startDate: new Date(dateLimit.getThreeMonth()).getTime(),
        endDate: WUYI.time.timeend + 8.64e7 - 1000,
        keyword: ''
      },
      pickerOptions: {
        disabledDate(time) {
          if (time.getTime() > Date.now()) return true;
          return false;
        }
      },
      tableData: {
        total: 0,
        data: []
      },
      cache: {}
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    selectTimeChange(val) {
      this.filter.endDate = val + 8.64e7 - 1000;
    },
    handleSearch() {
      if ((!this.filter.startDate && this.filter.endDate) || (this.filter.startDate && !this.filter.endDate)) {
        this.$message.error('请选择完整的时间范围');
        return false;
      }
      if (new Date(this.filter.startDate).getTime() > new Date(this.filter.endDate).getTime()) {
        this.$message.error('开始时间不能大于结束时间');
        return false;
      }
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.featchData();
    },
    featchData() {
      let options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.cache
      };
      axiosNew.post(api.queryWhiteListAddresses, options).then(res => {
        this.tableData.data = res.data.data || [];
        this.tableData.total = res.data.total;
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.featchData();
    },
    handleAdd() {
      this.$router.push({
        path: '/abnomalLocationAdd'
      });
    },
    // 查看定位
    handleToMap(item) {
      this.$router.push({
        path: `/abnomalLocationDtl/${item.id}`
      });
    },
    // 移除白名单
    handleRemove(item) {
      this.$confirm(`确认移除白名单`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          axiosNew
            .post(api.delWhiteListAddresses, {
              id: item.id
            })
            .then(res => {
              this.handleSearch();
            });
        })
        .catch(() => {});
    }
  }
};
</script>
